import React, {Component} from 'react';
import {NavLink} from 'react-router-dom'
import TTLProxy from "../../common/TTLAsyncProxy";
import HTML from '../../common/HtmlHelpers';
import NavigationLinks from './NavLinks';
import {getSetting} from "../../common/LocalSettings/LocalSettings";
import PropTypes from 'prop-types';
import AppGlobals from "../../common/AppGlobals";

const LinkSymbols = {
    ELEMENT: '$element$',
    DEPARTMENT: '$department$',
    AUTHENTICATION : '$auth$',
    PERMISSIONS: '$permissions$'
};


class Sidebar extends Component {

    static toggleState(state){
        document.body.classList.toggle(state);
    }

    static propTypes= {
       subMenuOffset: PropTypes.number
    };

    static defaultProps = {
        subMenuOffset : 10
    };

    proxy = TTLProxy.getInstance();

    constructor(props){
        super(props);

        this.state = {
            role: this.proxy.getUserRole()
        };
    }

    handleGroupClick(e) {
        e.preventDefault();
        e.target.parentElement.classList.toggle('open');
    }

    handleNavItemClick(path){

        if(getSetting('toggle_sidebar')) {
            Sidebar.toggleState(AppGlobals.get('isMobile') ? 'sidebar-mobile-show' : 'sidebar-hidden');
        }

    }

    activeRoute(routeName) {
        return this.props.location.pathname.indexOf(routeName) > -1 ? 'nav-item nav-dropdown open' : 'nav-item nav-dropdown';
    }

    // secondLevelActive(routeName) {
    //   return this.props.location.pathname.indexOf(routeName) > -1 ? "nav nav-second-level collapse in" : "nav nav-second-level collapse";
    // }

    renderElement(element,key){

        switch (element) {
            case "separator":
            case "divider": {
                return (<li className="divider" key={key}/>);
            }
        }

    }

    canRender(auth){

        switch (auth) {
            case 'super':{

                const user = this.proxy.getUserInfo();
                if(user && user.admin && user.admin.super_user){
                    return true;
                }

            }break;
        }


        return false;
    }

    hasDepartment(department){

        const user = this.proxy.getUserInfo();
        if(!user.admin.departments){
            return false;
        }

        return !!user.admin.departments.find(d => {

            for(let i = 0 , len = department.length ; i < len ; i++){
                if(d === department[i])
                    return true;
            }

        });

    }

    hasPermission(permissions){

        const user = this.proxy.getUserInfo();
        const userPermissions = user.permissions;
        if(userPermissions[0] === "*")
            return true;

        for(let i = 0 , len = permissions.length ; i < len ; i++){

            if(!userPermissions.includes(permissions[i]))
                return false;

        }

        return  true;
    }

    renderAuth(frame,renderContent){

        if(frame.hasOwnProperty(LinkSymbols.AUTHENTICATION)){

            if(this.canRender(frame[LinkSymbols.AUTHENTICATION]))
                return renderContent();

        }
        else if(frame.hasOwnProperty(LinkSymbols.DEPARTMENT)){

            if(this.hasDepartment(frame[LinkSymbols.DEPARTMENT]))
                return renderContent();
        }
        else if(frame.hasOwnProperty(LinkSymbols.PERMISSIONS)){

            if(this.hasPermission(frame[LinkSymbols.PERMISSIONS]))
                return renderContent();

        }
        else{
            return renderContent();
        }

    }

    renderLink(link,key , offset = 0){

        if(link.hasOwnProperty('groups')){

            return <div key={key}>
                <li className="divider"/>
                {link.title && <li className="nav-title">{link.title}</li>}
                {link.hasOwnProperty(LinkSymbols.ELEMENT) ?  this.renderElement(link[LinkSymbols.ELEMENT],key) : link.groups.map((g,k) => g.hasOwnProperty(LinkSymbols.ELEMENT) ? this.renderElement(g[LinkSymbols.ELEMENT],k) :

                    this.renderAuth(g,() => {

                        const links = g.subLinks.map((x,index) => x.hasOwnProperty(LinkSymbols.ELEMENT) ? this.renderElement(x[LinkSymbols.ELEMENT],index) :  this.renderLink(x,index,offset + this.props.subMenuOffset));
                        return (!links.every(x => x === undefined)) && <li className="nav-item nav-dropdown" key={k}>
                            <a className="nav-link nav-dropdown-toggle" href="#" onClick={this.handleGroupClick}>{HTML.renderIcon(g.icon)} {g.label}</a>
                            <ul className="nav-dropdown-items">
                                {links}
                            </ul>
                        </li>;

                    })
                )}
            </div>
        }
        else{

           return this.renderAuth(link, () => <li key={key} className="nav-item" onClick={this.handleNavItemClick.bind(this,link.path)}>
                <NavLink to={link.path} className="nav-link" activeClassName="active">
                    <span style={{marginLeft: offset}}>{HTML.renderIcon(link.icon)} {link.label}</span>
                </NavLink>
            </li>);
        }

    }

    render() {

        const links = NavigationLinks[this.state.role];
        return (<div className="sidebar">
              <nav className="sidebar-nav">
                <ul className="nav">
                    {links.map((l,index) => this.renderLink(l,index))}
                </ul>
              </nav>
            </div>
        )
    }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js